import moment from 'moment';
import { ACTIONS } from 'actions/record-system-health-check';

const initialState = {
  eventType: null,
  eventTime: '',
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.RECORD_SYSTEM_HEALTH_CHECK_EVENT: {
      const { eventType } = payload;

      return {
        eventType,
        eventTime: String(Number(moment())),
      };
    }
    default:
      return state;
  }
}
